import type { ReactNode } from 'react';
import { cx } from './cx';

export interface CardProps {
  children: ReactNode;
  className?: string;
  elevated?: boolean;
  padded?: boolean;
}

export function Card({ children, className, elevated = false, padded = true }: CardProps) {
  return (
    <div
      className={cx(
        'rounded-xl border',
        elevated
          ? 'bg-slate-800/80 border-slate-700/80 shadow-[0_4px_25px_-5px_rgba(0,0,0,0.2)]'
          : 'bg-slate-800/50 border-slate-700',
        padded && 'p-5',
        className,
      )}
    >
      {children}
    </div>
  );
}
